<template>
  <div v-if="!cookieAccepted" id="cookie-box">
    <div>
      Nasza strona używa plików cookie (tzw. ciasteczka) w celach
      statystycznych, reklamowych oraz funkcjonalnych. Więcej informacji
      znajdziesz w naszej <a href="/prywatnosc">Polityce prywatności</a>
      <span class="cookie-ok" @click="acceptCookies">OK</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cookieAccepted: false,
    };
  },
  mounted() {
    this.checkCookie();
  },
  methods: {
    acceptCookies() {
      this.cookieAccepted = true;
      this.setCookie("cookieAccepted", "true", 365);
    },
    setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
    },
    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
          return cookieValue;
        }
      }
      return null;
    },
    checkCookie() {
      if (this.getCookie("cookieAccepted") === "true") {
        this.cookieAccepted = true;
      }
    },
  },
};
</script>

<style scoped>
#cookie-box a {
  color: #FF6436;
  cursor: pointer;
}
#cookie-box {
  position: fixed;
  font-size: 0.85rem;
  bottom: 0;
  left: 0;
  width: 100%;
  max-width: 100vw;
  z-index: 9999;
  line-height: 1.7;
  background-color: #fff;
  padding: 1rem;
  text-align: center;
  color: #21397D
}
@media (min-width: 992px) {
  #cookie-box {
    width: 22rem;
    right: 0;
  }
}
.cookie-ok {
  display: inline-block;
  background: #21397D;
  cursor: pointer;
  color: #fff;
  padding: 0.25rem 0.65rem;
  margin-left: 0.75rem;
}
</style>
